export const ENDPOINT = 'api/app/profile';

export type Request = void;

export type Response = {
  id: string;
  name: string;
  email: string;
  phone: string;
  avatar: string | null;
  cpf: string;
  created_at: string;
  updated_at: string;
  // PRAT-161: e-mail genérico (telefone@cliente.pratigo.app...) não aparece na tela.
  email_is_generic?: boolean;
  email_verified?: boolean;
  email_pending?: string | null;
  /** PRAT-161: AAAA-MM-DD, opcional. */
  birth_date?: string | null;
};
